import { FC } from 'react'
import { RolexRcpoCollectionBannerItemV7 } from '@lib/kontent/models/RolexRcpoCollectionBannerItemV7'
import { Item } from '@lib/kontent'
import { RolexTextBlock } from '@components/_rolex/TextBlock'
import { RolexImage } from '@components/_rolex/Image'

type Props = {
  modularContentItem: Item<RolexRcpoCollectionBannerItemV7>
}

const ProductCollectionInfo: FC<Props> = ({ modularContentItem }) => {
  const { info_title, info_description, info_mobile_image, info_desktop_image } =
    modularContentItem.elements

  return (
    <section>
      <RolexTextBlock
        key={modularContentItem.system.id}
        title={info_title.value}
        description={info_description.value}
        className="!mb-10"
      />
      <RolexImage
        key={modularContentItem.system.id}
        mobileImage={info_mobile_image}
        desktopImage={info_desktop_image}
        size="l"
      />
    </section>
  )
}

export default ProductCollectionInfo
